export default function ProgressDot() {

    return (
        <span className="progress-dot"></span>
    )

}